import { atom } from 'jotai'
import { DefaultShowsFilters, FilterObject } from '@/lib/types/showsFilters'

const showsFiltersAtom = atom<FilterObject>(DefaultShowsFilters)

export { showsFiltersAtom }
